import { useInfiniteQuery } from "@tanstack/react-query";
import CCService from "../../services/httpServiceWithoutSuperAdmin";

const fetchRecruiterRequests = async ({ pageParam = 1, limit = 20, statusFilters = null }) => {
  const service = new CCService();
  
  // Build query parameters
  const params = new URLSearchParams({
    page: pageParam.toString(),
    limit: limit.toString(),
  });
  
  // Add status filters if provided
  if (statusFilters) {
    params.append('status', statusFilters);
  }
  
  const response = await service.get(`/cee/recruiter/recruiter-requests?${params.toString()}`);
  
  return {
    data: response.data.recruiterRequests,
    nextPage: response.data.pagination.hasNextPage ? pageParam + 1 : undefined,
    hasMore: response.data.pagination.hasNextPage,
    pagination: response.data.pagination,
  };
};

export function useRecruiterRequests(statusFilters = null) {
  return useInfiniteQuery({
    queryKey: ['recruiter-requests', 'list', { statusFilters }],
    queryFn: ({ pageParam }) =>
      fetchRecruiterRequests({
        pageParam,
        limit: 20,
        statusFilters,
      }),
    getNextPageParam: (lastPage, pages) => lastPage.nextPage,
    initialPageParam: 1,
    staleTime: 10 * 60 * 1000, // 10 minutes
    gcTime: 15 * 60 * 1000, // 15 minutes
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}